var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDistributionBlk = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18,9,14.625,6.75V8.438H10.687V2.813h3.938V4.5L18,2.25,14.625,0V1.688H9.562v6.75H6.75V5.625H0v6.75H6.75V9.563H9.562v6.75h5.063V18L18,15.75,14.625,13.5v1.688H10.687V9.563h3.938V11.25ZM5.625,11.25h-4.5V6.75h4.5Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDistributionBlk);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/distribution-blk.cc92263ec795ec2886a234fc1a0554ce.svg";